import React from 'react';

interface QuizResultsProps {
  quizResult: any;
  setQuizResult: (result: any) => void;
  setCurrentView: (view: 'lesson') => void;
  startQuiz: () => void;
}

export const QuizResults: React.FC<QuizResultsProps> = ({
  quizResult,
  setQuizResult,
  setCurrentView,
  startQuiz
}) => {
  if (!quizResult) return null;

  return (
    <div style={{ maxWidth: '600px', margin: '0 auto' }}>
      <div style={{ background: 'white', borderRadius: '24px', padding: '32px', textAlign: 'center' }}>
        <h2 style={{ marginBottom: '24px' }}>Quiz Results</h2>
        <div style={{ width: '120px', height: '120px', margin: '0 auto 20px', background: '#f0fdf4', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span style={{ fontSize: '32px', fontWeight: 'bold', color: '#15803d' }}>{Math.round(quizResult.score)}%</span>
        </div>
        <p style={{ marginBottom: '24px' }}>You got {quizResult.correct} out of {quizResult.total} correct</p>
        
        {quizResult.recommendations && (
          <div style={{ background: '#eff6ff', padding: '20px', borderRadius: '16px', textAlign: 'left', marginBottom: '24px' }}>
            <h3 style={{ marginBottom: '12px' }}>📌 Recommendations</h3>
            <ul style={{ marginLeft: '20px' }}>
              {quizResult.recommendations.map((rec: string, i: number) => (
                <li key={i} style={{ marginBottom: '8px' }}>{rec}</li>
              ))}
            </ul>
          </div>
        )}
        
        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          <button
            onClick={() => { setQuizResult(null); setCurrentView('lesson'); }}
            style={{ flex: 1, padding: '12px', background: '#6b7280', color: 'white', border: 'none', borderRadius: '12px', cursor: 'pointer' }}
          >
            Back to Lesson
          </button>
          <button
            onClick={() => startQuiz()}
            style={{ flex: 1, padding: '12px', background: '#22c55e', color: 'white', border: 'none', borderRadius: '12px', cursor: 'pointer' }}
          >
            Try Again
          </button>
        </div>
      </div>
    </div>
  );
};
